import { _decorator, Component } from 'cc';

const { ccclass, property, executeInEditMode } = _decorator;

@ccclass('ScaleScalar')
@executeInEditMode
export default class ScaleScalar extends Component {
    @property
    public set value(value: number) {
        if (typeof value !== 'number' || Number.isNaN(value)) {
            throw new Error(`invalid value: ${value}`);
        }
        this.node.scaleScalar = value;
    }
    public get value() {
        return this.node.scaleScalar;
    }
}
